import script from "./hotGoodsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./hotGoodsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./hotGoodsDetails.vue?vue&type=style&index=0&id=22a29f29&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a29f29"]])

export default __exports__